import React, { useState } from "react";
import { storageRef } from "_firebase";
import { connect } from "react-redux";

import organizationActions from "store/organizations/actions";

import UploadLogo from "./UploadLogo";
import NoLogoUploaded from "./NoLogoUploaded";

import PencilIcon from "assets/images/icons/white-pencil.svg";

import classes from "./style.module.scss";

const { updateOrganization } = organizationActions;

const OrgLogo = ({ logoUrl, organizationDetails, orgId, uid, updateOrganization, IS_ADMIN = false, setAlert }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [uploadState, setUploadState] = useState({
        isDraggingOver: false,
        dropError: false,
        progress: 0,
        isUploading: false,
    });

    // Every exit from here has to put the cursor back: an upload that finished while the wheel
    // was still spinning read as an upload that never ended.
    const endUpload = () => {
        document.body.style.cursor = "default";
        setUploadState((prev) => ({ ...prev, isUploading: false, progress: 0 }));
    };

    const handleUpload = (e, isDropdown) => {
        e.preventDefault();

        const { files } = isDropdown ? e.dataTransfer : e.target;

        const file = files[0];

        if (!file) return;

        if (!file.type.includes("image")) {
            setUploadState((prev) => ({ ...prev, isDraggingOver: false, dropError: true }));
            return;
        }

        document.body.style.cursor = "progress";

        setUploadState((prev) => ({
            ...prev,
            isDraggingOver: false,
            dropError: false,
            isUploading: true,
            progress: 0,
        }));

        const uploadTask = storageRef.child(`${uid}/organization/${orgId}/${file.name}`).put(file);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);

                setUploadState((prev) => ({ ...prev, progress, isUploading: true }));
            },
            (error) => {
                console.error(error.message);

                endUpload();
                setUploadState((prev) => ({ ...prev, dropError: true }));
                setAlert({
                    open: true,
                    message: "The logo could not be uploaded. Please try again.",
                    anchorOrigin: { vertical: "top", horizontal: "center" },
                    direction: "down",
                    severity: "error",
                });
            },
            () => {
                uploadTask.snapshot.ref
                    .getDownloadURL()
                    .then(async (downloadURL) => {
                        await updateOrganization(orgId, {
                            ...organizationDetails,
                            orgMeta: { ...organizationDetails.orgMeta, logoUrl: downloadURL },
                        });

                        setAlert({
                            open: true,
                            message: "Logo uploaded successfully!",
                            anchorOrigin: { vertical: "top", horizontal: "center" },
                            direction: "down",
                            severity: "success",
                        });

                        setIsHovered(false);
                    })
                    .finally(endUpload);
            }
        );
    };

    return logoUrl && !uploadState.isUploading ? (
        <div
            className={classes.logoContainer}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {IS_ADMIN && (
                <div className={`${classes.editLogoContainer} ${isHovered ? classes.showEditLogoContainer : ""}`}>
                    <img src={PencilIcon} alt="Edit Logo" />
                    <input
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            cursor: "pointer",
                        }}
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleUpload(e, false)}
                    />
                </div>
            )}
            <img src={logoUrl} alt="Organization Logo" />
        </div>
    ) : IS_ADMIN ? (
        <UploadLogo handleUpload={handleUpload} uploadState={uploadState} setUploadState={setUploadState} />
    ) : (
        <NoLogoUploaded />
    );
};

const mapDispatchToProps = (dispatch) => ({
    updateOrganization: (orgId, orgData) => dispatch(updateOrganization(orgId, orgData)),
});

export default connect(null, mapDispatchToProps)(OrgLogo);
